import React from 'react'
import classNames from 'classnames'

import { StateProvider, getHTML, JobOpeningsQuery } from '../../core'
import MediaWithContent from '../MediaWithContent'

import './job-openings.scss'

class MapSection extends React.Component {
  render() {
    const data = this.props.data || {}
    const context = this.props.context || {}

    const { 
      displayTitle,
      button,
    } = data

    return (
      <section styleName="job-openings-section">
        <div styleName="anchor" id="openings" />
        <h3>{displayTitle}</h3>

        <JobOpeningsQuery
          render={({ data }) => {
            const departments = {};
            (data.jobOpenings || []).forEach(o => {
              departments[o.department] = departments[o.department] || []
              departments[o.department].push(o)
            })

            return (
              <div styleName="departments">
                {Object.keys(departments)
                  .sort()
                  .map((key, j) => {
                    const openings = departments[key]

                    return (
                      <div styleName="department" key={j}>
                        <h2>{key}</h2>
                      
                        <div styleName="job-openings">
                          {openings.map((opening, i) => {
                            const address = opening.location || {}
                            return (
                              <a 
                                styleName="job-opening" 
                                key={i} 
                                href={opening.link} 
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <h3>{opening.title}</h3>
                                <h2>{address.city}, {address.state}</h2>
                              </a>
                            )
                          })}
                        </div>
                      </div>
                    )
                  })}
              </div>
            )
          }}
        />

        {button &&
          <a href={button.link}>
            <button>
              {button.text}
            </button>
          </a>
        }
      </section>
    )
  }
}

export default MapSection